import { render } from "./WhySection.vue?vue&type=template&id=153b8dfa&scoped=true"
const script = {}

import "./WhySection.vue?vue&type=style&index=0&id=153b8dfa&scoped=true&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-153b8dfa"]])

export default __exports__